// /my-productivity is in the base nav for every role, so it has to render the productivity page
// that fits the viewer — the same role switch Home.tsx does for dashboards. AE-and-above get the
// AE Productivity v2 design (led preprints, shepherding, their students); students and QC-in-
// training keep the student page (pitch funnel, badges), which would be meaningless for an AE.
// Exception: ?student=<email> opens that student's My Progress for AE drill-down from My Students.
import { useSearchParams } from "react-router-dom";
import { useCan } from "../../components/Can.js";
import { AeProductivity } from "./AeProductivity.js";
import { MyProductivity } from "./MyProductivity.js";

export function MyProductivityRoute(): JSX.Element {
  const [params] = useSearchParams();
  const student = params.get("student")?.trim() || "";
  // AE-and-above is exactly `advanceToPitchEditorial` with no domain scope — the same tell
  // Home.tsx uses to pick the AE dashboard.
  const isAe = useCan()("advanceToPitchEditorial", {});
  if (student) return <MyProductivity studentEmail={student} />;
  return isAe ? <AeProductivity /> : <MyProductivity />;
}
